import React from 'react'
import { toAbsoluteUrl } from '../../../../_metronic/_helpers'

import { Faq } from './Faq'
function AboutUs() {
  return (
    <>
      <div className="bg-white">
        <div className="abt_sc_1 mt-5">
          <div className="container container_frnt">
            <div className="row justify-content-center">
              <div className="col-md-12">
                <div className="top_img">
                  <img
                    alt=""
                    src={toAbsoluteUrl('/media/others/about_img.jpg')}
                    className="img-fluid"
                  />
                </div>
              </div>
              <div className="col-md-8 mt-20">
                <h2 className="def_hdng_v1 mb-8 ml-auto mr-auto">
                  About <span className="grbg_rndd">Us</span>
                </h2>
                <p className="def_p_v2 mb-8">
                  QRFID-GOLD is a public limited company based in Zug,
                  Switzerland, licenced to trade as a technology company which
                  created the QRFID-GOLD software
                </p>
                <p className="def_p_v2 mb-8">
                  The Founding Team Members first met at a chance encounter when
                  investing in an earlier gold-backed Stablecoin three years
                  ago. Since then they have been discussing the various benefits
                  and shortcomings of the gold-backed Stablecoins and realized
                  that none was meeting their expectations. QRFID-GOLD was
                  brought into creation to finally address their concerns for
                  security and actual store of value often seen lacking by
                  competing Stablecoins.
                </p>
                <h6 className="fn_s_20 f-w-400 color_blk mb-8 ab_sc_1pdlf">
                  The entire approach has been driven from a consumer-mindset,
                  with the founding members wanting a Stablecoin not created
                  from a Silicon Valley viewpoint, but rather from that of
                  serious business owners. QRFID-GOLD has been created to be a
                  simple cryptocurrency that has real proven substance whilst
                  simultaneously offering users a viable investment alternative
                  to the myriad of complex and opaque offerings that the
                  crypto-market has created.
                </h6>
                <p className="def_p_v2 mb-8">
                  Switzerland was chosen to be the country for the incorporation
                  of the company due to the robust financial regulatory system
                  and strong cryptocurrency culture. By allowing the company to
                  be incorporated in Switzerland, QRFID-GOLD is able to offer
                  significant peace to mind to investors, knowing that the
                  company has been subjected to some of the most stringent
                  financial regulatory controls within the major economies. This
                  in turn lends QRFID-GOLD some real weight and oversight for
                  its customers when compared to many of the other
                  cryptocurrencies in existence.
                </p>
                <p className="def_p_v2 mb-8">
                  As the company itself is based in Switzerland, QRFID-Gold has
                  made sure that the gold itself is licenced to be stored under
                  the registered gold dealers in Switzerland using an
                  independent third party that owns and runs its own secure
                  ex-military bunker, kept under a specific protocol overseen by
                  Swiss notaries. The gold therefore cannot be removed by anyone
                  without notifying the Swiss notaries, who in turn issue
                  regular audits to prove the existence of all the gold. Should
                  anyone try to remove any gold, both the Swiss bunker owners
                  and the Swiss Notary must be in attendance and agree that the
                  removal is in accordance with the official protocols. All gold
                  that is brought to the secure storage facility is the property
                  of the User who bought it through the gold dealer, hence they
                  are the official owners of the gold that those Tokens that
                  they represent at all times, hence no one from QRFID-GOLD is
                  able to remove them. The Founders made sure that the system is
                  fool-proof and that not even debts or leveraging of the gold
                  in the vaults can be made. The gold belongs solely to the
                  Token holders, and that is core to the idea of QRFID-GOLD.
                </p>
              </div>
              {/* <div className="col-md-12 text-center mrgn_tp_80 mb-10">
                <h3 className="fn_s_24 f-w-500 color_blk">PARTNERS</h3>
                <ul className="clnts_list">
                  <li>
                    <img
                      alt=""
                      src={toAbsoluteUrl("/media/others/cl_img1.png")}
                      className="img-fluid"
                    />
                  </li>
                  <li>
                    <img
                      alt=""
                      src={toAbsoluteUrl("/media/others/cl_img2.png")}
                      className="img-fluid"
                    />
                  </li>
                  <li>
                    <img
                      alt=""
                      src={toAbsoluteUrl("/media/others/cl_img3.png")}
                      className="img-fluid"
                    />
                  </li>
                  <li>
                    <img
                      alt=""
                      src={toAbsoluteUrl("/media/others/cl_img4.png")}
                      className="img-fluid"
                    />
                  </li>
                  <li>
                    <img
                      alt=""
                      src={toAbsoluteUrl("/media/others/cl_img5.png")}
                      className="img-fluid"
                    />
                  </li>
                  <li>
                    <img
                      alt=""
                      src={toAbsoluteUrl("/media/others/cl_img6.png")}
                      className="img-fluid"
                    />
                  </li>
                  <li>
                    <img
                      alt=""
                      src={toAbsoluteUrl("/media/others/cl_img2.png")}
                      className="img-fluid"
                    />
                  </li>
                  <li>
                    <img
                      alt=""
                      src={toAbsoluteUrl("/media/others/cl_img3.png")}
                      className="img-fluid"
                    />
                  </li>
                  <li>
                    <img
                      alt=""
                      src={toAbsoluteUrl("/media/others/cl_img4.png")}
                      className="img-fluid"
                    />
                  </li>
                  <li>
                    <img
                      alt=""
                      src={toAbsoluteUrl("/media/others/cl_img5.png")}
                      className="img-fluid"
                    />
                  </li>
                </ul>
              </div> */}
            </div>
          </div>
        </div>
        <div className="hm_sc_6 mrgn_tp_80">
          <div className="container container_frnt">
            <div className="row justify-content-center">
              <div className="col-md-12 text-center mb-10 mb-m-05">
                <h2 className="def_hdng_v1 mb-0 ml-auto mr-auto">
                  <span className="grbg_rndd">Frequently</span> Asked Questions
                </h2>
              </div>
              <div className="col-md-12">
                <Faq />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default AboutUs
